// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__JAIPl","notes":"Notes_notes__RxaQP","note":"Notes_note__3u7_C","markdown":"Notes_markdown__20uOq"};